import React, { PropTypes } from 'react';
import { Link } from 'react-router';
import classnames from 'classnames';

const Links = ({ groups, title, background, cta }) => (
  <section className={classnames("block block-links", background)}>
    <div className="row columns">
      <div className="block-header">
        <h2>{ title }</h2>
      </div>
    </div>

    <div className={`row medium-up-${groups.length}`}>
      { groups.map((links, i) => (
        <ul key={i} className="column">
          { links.map(({ label, url }, j) => (
            <li key={j}>
              <Link to={url} target="_blank">{ label }</Link>
            </li>
          )) }
        </ul>
      )) }
    </div>

    { cta &&
    <h3 className="text-center links-cta">
      <Link to={cta.link} target="_blank">{ cta.label }</Link>
    </h3> }
  </section>
);

Links.propTypes = {
  groups: PropTypes.array.isRequired,
  title: PropTypes.string.isRequired,
  background: PropTypes.string.isRequired,
  cta: PropTypes.object,
};

export default Links;



// WEBPACK FOOTER //
// ./landing_pages/components/links.jsx